import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <p>Loading...</p>; // prevents redirect during refresh
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
}